import { render, staticRenderFns } from "./signatures-index.vue?vue&type=template&id=04640fa6"
import script from "./signatures-index.vue?vue&type=script&lang=js"
export * from "./signatures-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports